import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function changePasswordFirstLogin (password, oldPassword) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(mock.getLogin)
      }, 500)
    })
  } else {
    const req = {
      url: 'api/login/changePassOnFirstLogin',
      method: 'POST',
      data: {
        Password: password,
        OldPassword: oldPassword,
      }
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { changePasswordFirstLogin }
